import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import Slider from '../slider/slider';
import displayNames from '../displayNames';

var OpacityPicker = function OpacityPicker(props) {
  return /*#__PURE__*/React.createElement(Slider, _.defaults({
    className: props.getClassName('opacity-slider'),
    unit: props.unit,
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props));
};

OpacityPicker.displayName = displayNames.OPACITY_PICKER;
OpacityPicker.propTypes = {
  value: PropTypes.number,
  opacityGradientColor: PropTypes.string,
  onChange: PropTypes.func,
  onSlideStart: PropTypes.func,
  onSlideEnd: PropTypes.func,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  unit: PropTypes.oneOf(['percent', ''])
};
OpacityPicker.defaultProps = {
  value: 100,
  opacityGradientColor: 'white',
  step: 1,
  min: 0,
  max: 100,
  unit: 'percent'
};
export default compose(OpacityPicker);